import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { onAuthStateChanged } from "firebase/auth";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { auth, db } from "../Config/firebase";
import { gerarSequencial, obterMaiorSequencial } from "../Utils/sequencial";
import RelatorioVisitaTecnicaPrint from "./RelatorioVisitaTecnicaPrint";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";

export const textosPadraoSimplesVisita = {
  objetivo:
    "Este relatório tem por objetivo apresentar parecer referente à visita técnica realizada nos locais informados pela empresa contratante.",
  metodologia:
    "As orientações técnicas seguiram as prescrições das normas da ABNT:\nNBR 5738:2015 - Concreto - Procedimento para moldagem e cura de corpos de prova;\nNBR 5739:2018 - Concreto - Ensaio de compressão de corpos de prova cilíndricos;\nNBR 16889:2020 - Determinação da consistência pelo abatimento do tronco de cone;\nNBR 12655:2022 - Concreto de cimento Portland - Preparo, controle, recebimento e aceitação - Procedimento;\nNBR 16886:2020 - Amostragem de concreto fresco;",
  resultadoAceitacao:
    "Para efeitos de aceitação do concreto, nos casos de não conformidade com os critérios da ABNT NBR 12655, deve ser considerado para comparação com fck o maior valor de resistência dos testemunhos extraídos de cada lote, corrigidos pelos coeficientes estabelecidos na NBR 7680.",
  parecerTitulo: "Identificação e Tratamento de Não conformidades",
  parecerDescricao:
    "Foi realizada visita técnica nos locais informados, sendo realizada inspeção e orientação relacionada ao controle de qualidade nas áreas avaliadas. Abaixo a relação dos itens evidenciados e suas devidas tratativas:",
  boasPraticasTitulo: "Boas práticas",
  boasPraticas: "",
  anexos:
    "Anexo 1 - Relatório fotográfico dos testemunhos extraídos, ensaio de carbonatação e inspeções nas áreas visitadas.",
  consideracoesFinais:
    "Foram feitos os treinamentos necessários para a realização das atividades relacionadas ao CONTROLE DE QUALIDADE. Após o fim do treinamento e a implantação das medidas indicadas, todas as atividades estavam de acordo com os procedimentos normativos necessários para a correta execução do projeto.",
};

export const textosPadraoVisita = {
  objetivo:
    "Este relatório tem por objetivo apresentar parecer referente à visita técnica realizada em 3 (três) canteiros (central de concreto, laboratório e atividade de campo) da empresa Tabocas na obra LT 500 KV MORRO DO CHAPÉU - POÇÕES III C2.",
  metodologia:
    "As orientações técnicas seguiram as prescrições das normas da ABNT:\nNBR 5738:2015 - Concreto - Procedimento para moldagem e cura de corpos de prova;\nNBR 5739:2018 - Concreto - Ensaio de compressão de corpos de prova cilíndricos;\nNBR 16889:2020 - Determinação da consistência pelo abatimento do tronco de cone;\nNBR 12655:2022 - Concreto de cimento Portland - Preparo, controle, recebimento e aceitação - Procedimento;\nNBR 16886:2020 - Amostragem de concreto fresco;",
  resultadoAceitacao:
    "Para efeitos de aceitação do concreto, nos casos de não conformidade com os critérios da ABNT NBR 12655, deve ser considerado para comparação com fck o maior valor de resistência dos testemunhos extraídos de cada lote, corrigidos pelos coeficientes estabelecidos na NBR 7680.",
  parecerTitulo: "Identificação e Tratamento de Não conformidades",
  parecerDescricao:
    "Foi realizada visita técnica em três canteiros da Tabocas, sendo eles, Biquera, Iramaia, Bom Jesus da Serra. Sendo realizada uma Inspeção e treinamento relacionado ao controle de qualidade nas seguintes áreas: central de concreto, laboratório e campo (concretagem das torres). Abaixo a relação dos itens evidenciados e suas devidas tratativas:",
  boasPraticasTitulo: "Boas práticas",
  boasPraticas:
    "A água de amassamento utilizada na Central de Concreto está sendo refrigerada para garantir que a temperatura máxima do concreto não ultrapasse limites que podem causar patologias às estruturas (procedimento adotado em todos os 3 (três) canteiros de obra inspecionados).",
  anexos:
    "Anexo 1 - Relatório fotográfico dos testemunhos extraídos, ensaio de carbonatação e inspeções nas áreas visitadas.",
  consideracoesFinais:
    "Foram feitos os treinamentos necessários para a realização das atividades relacionadas ao CONTROLE DE QUALIDADE. Após o fim do treinamento e a implantação das medidas indicadas, todas as atividades estavam de acordo com os procedimentos normativos necessários para a correta execução do projeto.",
};

export const textosLegadosVisita = {
  objetivo:
    "Este relatorio tem por objetivo apresentar parecer referente a visita tecnica realizada nos locais informados pela empresa contratante.",
  metodologia:
    "As orientacoes tecnicas seguiram as prescricoes das normas da ABNT:\nNBR 5738:2015 - Concreto - Procedimento para moldagem e cura de corpos de prova;\nNBR 5739:2018 - Concreto - Ensaio de compressao de corpos de prova cilindricos;\nNBR 16889:2020 - Determinacao da consistencia pelo abatimento do tronco de cone;\nNBR 12655:2022 - Concreto de cimento Portland - Preparo, controle, recebimento e aceitacao - Procedimento;\nNBR 16886:2020 - Amostragem de concreto fresco;",
  resultadoAceitacao:
    "Para efeitos de aceitacao do concreto, nos casos de nao conformidade com os criterios da ABNT NBR 12655, deve ser considerado para comparacao com fck o maior valor de resistencia dos testemunhos extraidos de cada lote, corrigidos pelos coeficientes estabelecidos na NBR 7680.",
  parecerTitulo: "Identificacao e Tratamento de Nao conformidades",
  parecerDescricao:
    "Foi realizada visita tecnica nos locais informados, sendo realizada inspecao e orientacao relacionada ao controle de qualidade nas areas avaliadas. Abaixo a relacao dos itens evidenciados e suas devidas tratativas:",
  anexos:
    "Anexo 1 - Relatorio fotografico dos testemunhos extraidos, ensaio de carbonatacao e inspecoes nas areas visitadas.",
  consideracoesFinais:
    "Foram feitos os treinamentos necessarios para a realizacao das atividades relacionadas ao CONTROLE DE QUALIDADE. Apos o fim do treinamento e a implantacao das medidas indicadas, todas as atividades estavam de acordo com os procedimentos normativos necessarios para a correta execucao do projeto.",
};

export function atualizarTextosPadraoLegados(dados) {
  return Object.keys(textosPadraoSimplesVisita).reduce(
    (resultado, campo) => ({
      ...resultado,
      [campo]:
        dados[campo] === undefined || dados[campo] === textosLegadosVisita[campo]
          ? textosPadraoSimplesVisita[campo]
          : dados[campo],
    }),
    dados
  );
}

const estadoInicialSimples = {
  codigo: "",
  dataRelatorio: new Date().toISOString().split("T")[0],
  cliente: "",
  clienteId: "",
  obra: "",
  obraId: "",
  local: "",
  segmento: "Concreto",
  ...textosPadraoSimplesVisita,
  parecerItens: [
    {
      local: "",
      naoConformidade: "",
      tratamento: "",
    },
  ],
  notasParecer: [""],
  relatorioFotografico: [],
};

const estadoInicialModeloCompleto = {
  codigo: "",
  dataRelatorio: new Date().toISOString().split("T")[0],
  cliente: "",
  clienteId: "",
  obra: "",
  obraId: "",
  local: "",
  segmento: "Concreto",
  ...textosPadraoVisita,
  parecerItens: [
    {
      local: "CENTRAL DE CONCRETO",
      naoConformidade:
        "Falha na execução do ensaio de abatimento (slump test): Camadas mal divididas, golpes realizados não atingindo toda a extensão da camada, velocidade de levantamento do cone fora do estabelecido na norma técnica do ensaio.",
      tratamento:
        "Foi realizado um treinamento para a equipe responsável por realizar o ensaio, informando a importância de dividir bem as camadas antes de executar os golpes e a velocidade de levantamento do cone que deve ser entre 4 a 6 segundos conforme a norma NBR 16889:2020 item 5.4 sem fazer movimento de torção com o mesmo.",
    },
    {
      local: "CENTRAL DE CONCRETO",
      naoConformidade: "",
      tratamento: "",
    },
    {
      local: "CENTRAL DE CONCRETO",
      naoConformidade: "",
      tratamento: "",
    },
    {
      local: "LABORATÓRIO",
      naoConformidade:
        "Retífica utilizada em 2 canteiros não estava retificando o Corpo de Prova dentro do esquadro.",
      tratamento:
        "Foram orientados a utilizarem, além do processo de retífica, Neoprene nas 2(duas) faces do corpo de prova para garantir que a ruptura seja o mais representativa possível.",
    },
    {
      local: "LABORATÓRIO",
      naoConformidade:
        "Em todas as prensas inspecionadas foi identificado defeito no prato superior.",
      tratamento:
        "Foi feita a orientação de como fazer o reparo na prensa de Bom Jesus devendo o mesmo processo ser replicado para as prensas dos outros laboratórios.",
    },
    {
      local: "LABORATÓRIO",
      naoConformidade:
        "Velocidade de carregamento do corpo de prova, em nenhum dos 03 canteiros a velocidade estava conforme normativa, NBR 5739, baixa ou alta demais, que é de 0,35 +/- 15 MPa/s",
      tratamento:
        "Foi feita a orientação para controlar a velocidade de incremento de carga durante a ruptura dos corpos de prova.",
    },
    {
      local: "CAMPO",
      naoConformidade:
        "Falha na execução do ensaio de abatimento (slump test): Camadas mal divididas, golpes realizados não atingindo toda a extensão da camada, velocidade de levantamento do cone fora do estabelecido na norma técnica do ensaio.",
      tratamento:
        "Foi realizado um treinamento para a equipe responsável por realizar o ensaio, informando a importância de dividir bem as camadas antes de executar os golpes e a velocidade de levantamento do cone que deve ser entre 4 a 6 segundos conforme a norma NBR 16889:2020 item 5.4 sem fazer movimento de torção com o mesmo.",
    },
    {
      local: "CAMPO",
      naoConformidade:
        "Foi identificado que as formas não estão sendo limpas adequadamente para a moldagem dos corpos de prova.",
      tratamento:
        "Foi orientado que fizesse mudanças no processo de limpeza das formas utilizando uma furadeira com uma escova de aço adaptada na ponta e escovas de aço até que a forma fique completamente sem resíduos da moldagem anterior.",
    },
    {
      local: "CAMPO",
      naoConformidade:
        "Foi identificado que estava sendo aplicado pouco desmoldante e o mesmo estava sendo aplicado na central de concreto.",
      tratamento:
        "Foi orientado que deve ser passado o desmoldante no local da concretagem pouco antes da moldagem para garantir que o mesmo não tenha escorrido e perdido a função de lubrificar a forma.",
    },
    {
      local: "CAMPO",
      naoConformidade:
        "Foi identificado que o desmoldante utilizado não era eficiente devido a rápida secagem do mesmo após ser passado nas formas",
      tratamento:
        "Foi recomendado que utilizassem óleo mineral ou óleo diesel S10 como lubrificante para melhor eficiência da lubrificação.",
    },
    {
      local: "CAMPO",
      naoConformidade:
        "Foi identificado que a coleta do concreto para a moldagem dos corpos de prova estava sendo feito no início do lançamento do concreto.",
      tratamento:
        "Foi orientado que o correto é coletar a amostra para fazer a moldagem dos corpos de prova após a retirada dos primeiros 15% descarregado e antes de 85% do volume total concreto do caminhão betoneira para depois fazer a coleta conforme solicitado na NBR 16886:2020 item 4.4.",
    },
  ],
  notasParecer: [
    "Foi orientado que o concreto saia da usina próximo do limite máximo do abatimento slump, que é de 12,0 cm, evitando desta forma a adição de água no campo.",
    "Está sendo realizado o ensaio de abatimento slump test na usina e no campo, vale ressaltar que o ensaio de slump test válido é somente aquele feito no campo, para liberação do concreto, e que considerando a perda inevitável de consistência do concreto é aceitável que o produto saia da usina com abatimento acima do limite do traço de concreto, desde que não ultrapasse a relação água cimento e percentual máximo de aditivo calculado para a dosagem.",
  ],
  relatorioFotografico: [],
};

function estadoInicialParaNovoRelatorio(quantidadeRelatorios) {
  return quantidadeRelatorios === 0 ? estadoInicialModeloCompleto : estadoInicialSimples;
}

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = dataISO.split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function normalizarTexto(valor) {
  return String(valor || "").toLowerCase();
}

function calcularProximoCodigo(lista) {
  const ano = new Date().getFullYear();
  const numeros = lista
    .map((item) => String(item.codigo || "").match(/RE-VT-(\d+)\/\d{4}/))
    .filter(Boolean)
    .map((match) => Number(match[1]))
    .filter(Number.isFinite);
  const proximo = numeros.length ? Math.max(...numeros) + 1 : lista.length + 1;
  return `RE-VT-${String(proximo).padStart(3, "0")}/${ano}`;
}

export default function CadastroVisitaTecnica() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const history = useHistory();
  const [usuario, setUsuario] = useState(null);
  const [relatorios, setRelatorios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [obrasSistema, setObrasSistema] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [relatorioEditando, setRelatorioEditando] = useState(null);
  const [form, setForm] = useState(estadoInicialSimples);
  const [filtro, setFiltro] = useState("");
  const [modoPrint, setModoPrint] = useState(false);
  const [relatorioPrint, setRelatorioPrint] = useState(null);
  const [autoPrint, setAutoPrint] = useState(false);
  const [itensPerPage, setItensPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setUsuario(null);
        return;
      }

      const snap = await getDoc(doc(db, "users", user.uid));
      setUsuario(snap.exists() ? { uid: user.uid, ...snap.data() } : { uid: user.uid });
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    carregarRelatorios();
    carregarClientes();
  }, []);

  async function carregarRelatorios() {
    setLoading(true);
    const q = query(collection(db, "tblRelatoriosVisitaTecnica"), orderBy("criadoEm", "desc"));
    const snap = await getDocs(consultaTenantAtual(q));
    setRelatorios(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
    setLoading(false);
  }

  async function carregarClientes() {
    const q = query(collection(db, "clientes"), orderBy("nome", "asc"));
    const snap = await getDocs(consultaTenantAtual(q));
    setClientes(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  async function carregarObrasPorCliente(clienteId) {
    if (!clienteId) {
      setObrasSistema([]);
      return;
    }

    const q = query(collection(db, "obras"), where("clienteId", "==", clienteId), orderBy("nome", "asc"));
    const snap = await getDocs(consultaTenantAtual(q));
    setObrasSistema(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  function abrirNovoCadastro() {
    setModoEdicao(false);
    setRelatorioEditando(null);
    setClienteSelecionado(null);
    setObrasSistema([]);
    const estadoNovoRelatorio = estadoInicialParaNovoRelatorio(relatorios.length);
    setForm({
      ...estadoNovoRelatorio,
      dataRelatorio: new Date().toISOString().split("T")[0],
    });
    setOpenDialog(true);
  }

  async function editarRelatorio(relatorio) {
    setModoEdicao(true);
    setRelatorioEditando(relatorio);

    const clienteEncontrado = clientes.find((cliente) => cliente.id === relatorio.clienteId);
    setClienteSelecionado(clienteEncontrado || null);

    if (relatorio.clienteId) {
      await carregarObrasPorCliente(relatorio.clienteId);
    }

    setForm({
      ...estadoInicialSimples,
      ...relatorio,
      parecerItens: Array.isArray(relatorio.parecerItens) && relatorio.parecerItens.length
        ? relatorio.parecerItens
        : estadoInicialSimples.parecerItens,
      notasParecer: Array.isArray(relatorio.notasParecer) ? relatorio.notasParecer : [""],
    });
    setOpenDialog(true);
  }

  function selecionarObra(obraId) {
    const obraSelecionada = obrasSistema.find((obra) => obra.id === obraId);
    setForm({
      ...form,
      obra: obraSelecionada?.nome || "",
      obraId: obraSelecionada?.id || "",
      local: obraSelecionada?.endereco || obraSelecionada?.local || form.local || "",
    });
  }

  async function salvarRelatorio() {
    if (!form.clienteId || !form.obraId) {
      alert("Selecione o cliente e a obra antes de salvar.");
      return;
    }

    const codigo = modoEdicao
      ? form.codigo
      : form.codigo || (await gerarSequencial({
          chave: "visita_tecnica",
          escopo: new Date(form.dataRelatorio || new Date()).getFullYear(),
          formato: {
            padding: 3,
            ano: new Date(form.dataRelatorio || new Date()).getFullYear(),
            template: "RE-VT-{numero}/{ano}",
          },
          valorMinimo: obterMaiorSequencial(relatorios, /RE-VT-(\d+)\/\d{4}/),
        })).codigo;

    const dados = {
      ...form,
      codigo,
      atualizadoEm: new Date(),
      atualizadoPor: usuario?.uid || null,
    };

    if (modoEdicao && relatorioEditando?.id) {
      await updateDoc(doc(db, "tblRelatoriosVisitaTecnica", relatorioEditando.id), dados);
    } else {
      await addDoc(collection(db, "tblRelatoriosVisitaTecnica"), aplicarTenantAtual({
        ...dados,
        criadoEm: new Date(),
        criadoPor: usuario?.uid || null,
      }));
    }

    setOpenDialog(false);
    await carregarRelatorios();
  }

  async function abrirRelatorio(relatorio, imprimir = false) {
    let relatorioAtualizado = relatorio;

    if (relatorio?.id) {
      const snap = await getDoc(doc(db, "tblRelatoriosVisitaTecnica", relatorio.id));
      if (snap.exists()) {
        relatorioAtualizado = { id: snap.id, ...snap.data() };
      }
    }

    setRelatorioPrint(atualizarTextosPadraoLegados(relatorioAtualizado));
    setAutoPrint(imprimir);
    setModoPrint(true);
  }

  const relatoriosFiltrados = useMemo(() => {
    const termo = normalizarTexto(filtro);
    if (!termo) return relatorios;

    return relatorios.filter((item) =>
      [item.codigo, item.cliente, item.obra, item.local, item.segmento, item.dataRelatorio].some((valor) =>
        contemTextoPesquisa(normalizarTexto(valor), termo)
      )
    );
  }, [relatorios, filtro]);

  const inicio = currentPage * itensPerPage;
  const fim = inicio + itensPerPage;
  const relatoriosPaginados = relatoriosFiltrados.slice(inicio, fim);

  if (modoPrint && relatorioPrint) {
    return (
      <RelatorioVisitaTecnicaPrint
        relatorio={relatorioPrint}
        autoPrint={autoPrint}
        onVoltar={() => {
          setModoPrint(false);
          setAutoPrint(false);
          setRelatorioPrint(null);
        }}
      />
    );
  }

  return (
    <>
      <Navbar />

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h6" fontWeight={700}>Relatórios Visita Técnica</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Lista de relatórios cadastrados</Typography>
        <Stack direction={{ xs: "column", md: "row" }} alignItems="stretch" spacing={2} mb={3}>
          <Button variant="contained" onClick={abrirNovoCadastro}>+ Novo Relatório</Button>

          <TextField
            size="small"
            label="Pesquisar"
            placeholder="Código, cliente, obra, local ou segmento"
            value={filtro}
            onChange={(e) => {
              setFiltro(e.target.value);
              setCurrentPage(0);
            }}
            sx={{ flex: 1 }}
          />

          <TextField
            size="small"
            label="Qtd Relatórios"
            value={relatoriosFiltrados.length}
            InputProps={{ readOnly: true }}
            sx={{ width: { xs: "100%", md: 140 } }}
          />
        </Stack>
        </Paper>

        <Paper sx={{ borderRadius: "12px", overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}>
          <Table className="lista-cadastro-padrao" size="small" sx={{ minWidth: 900 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell><strong>Código</strong></TableCell>
                <TableCell>Cliente / Obra</TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Segmento</TableCell>
                <TableCell>Local</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {relatoriosPaginados.map((item) => (
                <TableRow
                  key={item.id}
                  hover
                  sx={{ height: 48, cursor: "pointer" }}
                  onClick={() => history.push(`/app/relatorios-visita-tecnica/${item.id}`)}
                >
                  <TableCell>{item.codigo || "-"}</TableCell>
                  <TableCell>
                    <div className="lista-dado-principal">{item.cliente || "-"}</div>
                    <div className="lista-dado-secundario">Obra: {item.obra || "-"}</div>
                  </TableCell>
                  <TableCell className="lista-dado-secundario">{formatarDataBR(item.dataRelatorio)}</TableCell>
                  <TableCell className="lista-dado-destaque">{item.segmento || "-"}</TableCell>
                  <TableCell className="lista-dado-secundario">{item.local || "-"}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Visualizar">
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          abrirRelatorio(item, false);
                        }}
                      >
                        <VisibilityIcon sx={{ color: "primary.main" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar cadastro">
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          editarRelatorio(item);
                        }}
                      >
                        <EditIcon sx={{ color: "#0288d1" }} />
                      </IconButton>
                    </Tooltip>
                    <HistoricoCadastro colecao="tblRelatoriosVisitaTecnica" documentoId={item.id} registro={item} />
                  </TableCell>
                </TableRow>
              ))}

              {loading && <TableRow><TableCell colSpan={6}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
              {!loading && relatoriosPaginados.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">Nenhum relatório cadastrado.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>

        <Stack direction="row" justifyContent="space-between" mt={2}>
          <TextField
            select
            size="small"
            label="Itens"
            value={itensPerPage}
            onChange={(e) => {
              setItensPerPage(Number(e.target.value));
              setCurrentPage(0);
            }}
            sx={{ width: 120 }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </TextField>

          <Stack direction="row" spacing={1}>
            <Button disabled={currentPage === 0} onClick={() => setCurrentPage((p) => p - 1)}>Anterior</Button>
            <Typography sx={{ display: "flex", alignItems: "center" }}>Página {currentPage + 1}</Typography>
            <Button disabled={fim >= relatoriosFiltrados.length} onClick={() => setCurrentPage((p) => p + 1)}>Próxima</Button>
          </Stack>
        </Stack>
      </Box>

      <Dialog open={openDialog} onClose={() => !salvandoCadastro && setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>{modoEdicao ? "Editar Relatório de Visita Técnica" : "Novo Relatório de Visita Técnica"}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} mt={1}>
            <TextField label="Código" value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value })} fullWidth />

            <TextField
              select
              label="Segmento"
              value={form.segmento}
              onChange={(e) => setForm({ ...form, segmento: e.target.value })}
              fullWidth
            >
              <MenuItem value="Concreto">Concreto</MenuItem>
              <MenuItem value="Solos">Solos</MenuItem>
              <MenuItem value="Asfalto">Asfalto</MenuItem>
              <MenuItem value="Geral">Geral</MenuItem>
            </TextField>

            <Autocomplete
              options={clientes}
              getOptionLabel={(option) => option?.nome || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={clienteSelecionado}
              onChange={(event, newValue) => {
                setClienteSelecionado(newValue);
                setForm({
                  ...form,
                  cliente: newValue?.nome || "",
                  clienteId: newValue?.id || "",
                  obra: "",
                  obraId: "",
                  local: "",
                });
                carregarObrasPorCliente(newValue?.id);
              }}
              renderInput={(params) => <TextField {...params} label="Cliente" placeholder="Pesquisar cliente..." fullWidth />}
            />

            <TextField
              select
              label="Empreendimento/Obra"
              value={form.obraId || ""}
              onChange={(e) => selecionarObra(e.target.value)}
              fullWidth
              disabled={!clienteSelecionado}
            >
              {obrasSistema.map((obra) => (
                <MenuItem key={obra.id} value={obra.id}>{obra.nome}</MenuItem>
              ))}
            </TextField>

            <TextField label="Local" value={form.local} onChange={(e) => setForm({ ...form, local: e.target.value })} fullWidth />

            <TextField
              label="Data do relatório"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={form.dataRelatorio}
              onChange={(e) => setForm({ ...form, dataRelatorio: e.target.value })}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} disabled={salvandoCadastro}>Cancelar</Button>
          <Button variant="contained" onClick={() => executarSalvamento(salvarRelatorio)} disabled={salvandoCadastro}>
            {salvandoCadastro ? "Salvando..." : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
